import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  TextField,
} from "@material-ui/core";
import AWS from "aws-sdk";
import Swal from "sweetalert2";
import { Auth } from "aws-amplify";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { Link } from "react-router-dom/cjs/react-router-dom";

export default function ServiceManual({ title, link }) {
  const [file, setFile] = useState(null);
  const [trainload, setTrainload] = useState(false);
  const [compareLoad, setCompareLoad] = useState(false);
  const [deleteError, setdeleteError] = useState("");
  const [file1, setFile1] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [pdfdone, setPdfDone] = useState(false);
  const [error, setError] = useState("");
  const [error1, setError1] = useState("");
  const [userquery, setUserQuery] = useState("");
  const [selectLanguageDisplay, setSelectLanguageDisplay] = useState("en");
  const [answerload, setAnswerload] = useState(false);
  const [trainError, setTrainError] = useState("");
  const [queryError, setQueryError] = useState("");

  const [transcript, setTranScript] = useState("");
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    if (transcript.length > 0) {
      let index = 0;
      const intevalId = setInterval(() => {
        setDisplayText((prev) => prev + transcript[index]);
        index++;
        if (index === transcript.length) {
          clearInterval(intevalId);
        }
      }, 10);
    }
  }, [transcript]);

  const deleteObjectsFromFolder = async () => {
    try {
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      const params = {
        Bucket: "python-libs-customchat",
        Prefix: username,
      };
      AWS.config.update({
        accessKeyId: "AKIA3AQTRT6P7J7N3JUJ",
        secretAccessKey: "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",
        region: "ap-south-1",
      });
      const s3 = new AWS.S3();
      const data = await s3.listObjectsV2(params).promise();

      if (data.Contents.length === 0) {
        console.log("No objects found in the folder.");
        return;
      }

      const objects = data.Contents.map(({ Key }) => {
        if (!Key.includes("/prompts/")) {
          return { Key };
        } else {
          return null;
        }
      });
      let array = objects.filter((element) => element !== null);
      await s3
        .deleteObjects({
          Bucket: "python-libs-customchat",
          Delete: { Objects: array },
        })
        .promise();

      console.log("Objects deleted successfully.");
      // setdeleteError("Trained data deleted successfully!");
    } catch (error) {
      console.error("Error deleting objects:", error);
      // setdeleteError("Error occured while deleting trained data!");
    }
  };

  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  const handleCompare = async () => {
    //add filename passing parameter in post request and run post request of chatbot
    if (!userquery) {
      setError("Please entre a query");
      return;
    }
    setError("");
    setDisplayText("");
    try {
      setCompareLoad(true); // Start the loading state
      const data = {
        question: userquery,
      };
      const trainoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      // Create the fetch request
      const requesttrain = await fetch(
        // "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/course-recommendation-response", // Replace with your actual AWS API endpoint
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/service-manual-chatbot", // Replace with your actual AWS API endpoint
        trainoption,
      );

      // Check if the response is successful
      if (!requesttrain.ok) {
        console.error(`HTTP error! status: ${requesttrain.status}`);
        return;
      }

      let response;
      try {
        response = await requesttrain.json();
      } catch (jsonError) {
        console.error("Error parsing JSON:", jsonError);
        return;
      }

      // Inspect the full response
      console.log("Full response:", response);

      // Handle the response based on the actual structure
      if (response?.messsage) {
        // Note the typo in "messsage"
        setTranScript(response.messsage);
        console.log("Response data:", response.messsage);
      } else {
        console.error("Unexpected response structure:", response);
      }

      // Log the data
      console.log("Response data:", response.messsage);
    } catch (error) {
      // Handle any errors
      console.error("There was an error with the fetch request:", error);
    } finally {
      setCompareLoad(false); // End the loading state
    }
  };

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
      {genaiaccess ? (
        <div
          style={{
            flex: "0.3",
            marginBottom: "1rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            width: "80vw",
            gap: "3rem",
            margin: "auto",
          }}
          className="input-form-chatbot"
        >
          <div className="section-container">
            <p>Please enter your prompt:</p>
            {/* <TextField
              id="outlined-basic"
              // label="Question"
              variant="outlined"
              InputLabelProps={{
                style: { color: 'white' },
              }}
              InputProps={{
                style: { color: 'white' }, // Input text color
              }}
              style={{
                border: "1px solid white",
                borderRadius: "0.5rem",
                width: "100%",
              }}
              value={userquery}
              onChange={(e) => setUserQuery(e.target.value)}
            /> */}
            <TextareaAutosize
              id="outlined-basic"
              minRows={1}
              value={userquery}
              onChange={(e) => setUserQuery(e.target.value)}
              style={{
                border: "1px solid white",
                borderRadius: "0.5rem",
                width: "100%",
                color: "white",
                backgroundColor: "transparent",
                padding: "16.5px 14px",
                fontSize: "16px",
                lineHeight: "1.4375em",
                resize: "none",
                overflow: "hidden",
                boxSizing: "border-box",
              }}
            />
            <Button
              style={{ margin: "1rem 0" }}
              variant="contained"
              color="primary"
              onClick={handleCompare}
              startIcon={
                compareLoad && <CircularProgress color="white" size={20} />
              }
            >
              Generate Answer
            </Button>
            <p>{error}</p>
          </div>
          <div className="section-container">
            <h4>
              <strong>Generated Response</strong>
            </h4>
            <hr style={{ background: "white" }}></hr>
            {displayText.length > 0 ? (
              <pre
                style={{
                  color: "white",
                  fontFamily: "sans-serif",
                  wordWrap: "break-word",
                  whiteSpace: "pre-wrap",
                }}
              >
                {displayText}
              </pre>
            ) : (
              "Response will be displayed here"
            )}
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
